import PenerimaanIndex from "@/components/claim/penerimaan/penerimaanIndex.vue";
import PenerimaanAdd from "@/components/claim/penerimaan/penerimaanAdd.vue";
import PenerimaanEdit from "@/components/claim/penerimaan/penerimaanEdit.vue";
import PenerimaanDetail from "@/components/claim/penerimaan/penerimaanDetail.vue";


let routesPenerimaan = [
  {
    path: '', // child default
    name: "penerimaan",
    component: PenerimaanIndex
  },
  {
    path: 'add', // child default
    name: "PenerimaanAdd",
    component: PenerimaanAdd
  },
  {
    path: 'edit/:id', // child default
    name: "PenerimaanEdit",
    component: PenerimaanEdit
  },
  {
    path: 'detail/:id', // child default
    name: "PenerimaanDetail",
    component: PenerimaanDetail
  },
  
];

export default routesPenerimaan;